import { createFileRoute } from '@tanstack/react-router';

import { SettingsPage } from '@/features/settings';

/** Any platform role may open it; the checks themselves are for owners and admins. */
export const Route = createFileRoute('/_authed/settings')({
  staticData: { crumbKey: 'nav.settings', tours: ['platform.settings'] },
  component: SettingsPage,
});
